import { Options } from "../../../../common/types/requestOptions";
import { api, Response } from "../../../../app/api";
import { EventPayload } from "../../../../common/types/Event";
import {
  CreateTaxWithholdingCorrection,
  DeleteTaxWithholdingCorrection,
  TalentTaxWithholdingCorrection,
  TaxWithholdingCorrectionCreated,
  TaxWithholdingCorrectionDeleted,
  TaxWithholdingUpdateEvent,
  UpdateTaxWithholdingCorrection,
} from "./types";

export const getTalentTaxWithholdingCorrections = (
  talentId: string,
  { requestId }: Options,
): Promise<Response<TalentTaxWithholdingCorrection[]>> => {
  return api.get<TalentTaxWithholdingCorrection[]>(
    "/invoicing/qry/talentTaxWithholdingCorrections",
    {
      requestId,
      queryParams: {
        talentId: talentId,
      },
      auth: true,
    },
  );
};

export const createTaxWithholdingCorrection = (
  command: CreateTaxWithholdingCorrection,
  { requestId }: Options,
): Promise<EventPayload<TaxWithholdingCorrectionCreated>[]> =>
  api
    .post<EventPayload<TaxWithholdingCorrectionCreated>[]>(
      "/invoicing/cmd/createTaxWithholdingCorrection",
      {
        requestId,
        auth: true,
        body: command,
      },
    )
    .then((res) => res.data);

export const updateTaxWithholdingCorrection = (
  command: UpdateTaxWithholdingCorrection,
  { requestId }: Options,
): Promise<EventPayload<TaxWithholdingUpdateEvent>[]> =>
  api
    .post<EventPayload<TaxWithholdingUpdateEvent>[]>(
      "/invoicing/cmd/updateTaxWithholdingCorrection",
      {
        requestId,
        auth: true,
        body: command,
      },
    )
    .then((res) => res.data);

export const deleteTaxWithholdingCorrection = (
  deleteTaxWithholdingCorrection: DeleteTaxWithholdingCorrection,
  { requestId }: Options,
): Promise<EventPayload<TaxWithholdingCorrectionDeleted>[]> =>
  api
    .post<EventPayload<TaxWithholdingCorrectionDeleted>[]>(
      "/invoicing/cmd/deleteTaxWithholdingCorrection",
      {
        requestId,
        auth: true,
        body: deleteTaxWithholdingCorrection,
      },
    )
    .then((res) => res.data);
